<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div>
            <h2 class="text-2xl font-semibold text-gray-900 dark:text-white">
                Podgląd faktury w KSeF
            </h2>
            <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Faktura: <span class="font-medium">{{ data.invoiceNumber }}</span>
            </p>
            <p class="text-xs text-gray-500 dark:text-gray-500 mt-1">
                Numer KSeF: {{ data.ksefNumber }}
            </p>
        </div>
        <button 
            mat-icon-button 
            (click)="close()"
            [matTooltip]="'Zamknij'">
            <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-hidden p-6 flex flex-col">
        
        <!-- Loading State -->
        <div *ngIf="isLoading" class="flex flex-col items-center justify-center py-12">
            <mat-spinner [diameter]="60"></mat-spinner>
            <p class="text-gray-600 dark:text-gray-400 mt-4">Pobieranie faktury z KSeF...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="!isLoading && error" class="flex flex-col items-center justify-center py-12">
            <mat-icon 
                class="text-red-500 mb-4" 
                [svgIcon]="'tabler_outline:alert-circle'" 
                style="width: 64px; height: 64px; font-size: 64px;">
            </mat-icon>
            <h3 class="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                Błąd pobierania faktury
            </h3>
            <p class="text-gray-600 dark:text-gray-400 text-center max-w-md">
                {{ error }}
            </p>
        </div>

        <!-- Success State - XML Content -->
        <div *ngIf="!isLoading && !error && invoiceXml" class="flex flex-col flex-1 overflow-hidden">
            <div class="flex items-center justify-between mb-4 flex-shrink-0">
                <div class="text-sm text-gray-600 dark:text-gray-400">
                    Zawartość XML faktury ({{ invoiceXml.length }} znaków)
                </div>
                <div class="flex gap-2">
                    <button 
                        mat-button 
                        color="primary"
                        (click)="copyToClipboard()"
                        [matTooltip]="'Kopiuj do schowka'">
                        <mat-icon [svgIcon]="'tabler_outline:copy'"></mat-icon>
                        <span class="ml-3">Kopiuj</span>
                    </button>
                    <button 
                        mat-button 
                        color="primary"
                        (click)="downloadXml()"
                        [matTooltip]="'Pobierz jako plik XML'">
                        <mat-icon [svgIcon]="'tabler_outline:download'"></mat-icon>
                        <span class="ml-3">Pobierz</span>
                    </button>
                </div>
            </div>

            <!-- XML Viewer with Syntax Highlighting -->
            <div class="xml-container bg-gray-900 rounded-lg flex-1">
                <textarea 
                    fakturnia-highlight
                    [code]="formattedXml"
                    [lang]="'xml'"
                    readonly>
                </textarea>
            </div>
        </div>

    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-2 p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
        <button 
            mat-flat-button 
            color="primary"
            (click)="close()">
            Zamknij
        </button>
    </div>
</div>

